import { SECTION_TYPES } from "@/lib/constants/sections";
import { Presentation } from "lucide-react";

const projectsSection = {
  type: SECTION_TYPES.PROJECTS,
  order: 2,
  content: {
    header: "Some recent projects ",
    subheader: "Check out some recent projects below, or see our entire project showcase",
  },
  meta: {
    displayName: "Projects",
    displayDescription: "Showcase your projects.",
    displayIcon: Presentation,
  },
};

export default projectsSection;
